/**
 * One condition, on or off, that takes effect the moment it is flipped: the
 * words beside the track are part of the control, so clicking them flips it
 * too. Picking items out of a set (columns, rows, stages) stays a checkbox.
 */
export function Switch(props: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <button
      className="switch"
      type="button"
      role="switch"
      aria-checked={props.checked}
      onClick={() => props.onChange(!props.checked)}
    >
      <span className="switch-track" aria-hidden="true">
        <span className="switch-thumb" />
      </span>
      {props.children}
    </button>
  );
}
